import { MakeCall } from 'ha/services/apiV2/createMakeCall';

// eslint-disable-next-line sort-imports
import { APIV2_URL } from './constants';
import { UserDocument, UserDocumentCategory } from './types/UserDocument';

interface Query {
  categories?: UserDocumentCategory;
  query?: string;
  orderBy?: string;
  limit?: number;
  offset?: number;
}

export interface UserDocumentsResponse {
  documents: UserDocument[];
  count: number;
}

export default (makeCall: MakeCall) => (userId: number | 'me', query?: Query) =>
  makeCall<UserDocumentsResponse>(
    'GET',
    `${APIV2_URL}/user/${userId}/document`,
    {
      query,
    },
  );
